$(document).ready(function(){
    var $quoteSliders = $('.quote-slider-container');

    $.each($quoteSliders, function (i, el) { 
        var $this = $(el);
        var $slides = $this.find('>div');
        
        if($slides.length > 1){
            //initialize slider
            $this.slick({
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            }).addClass('cca--initialized');
        }
    });
});